/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type BillingProcessStatus = 0 | 1 | 2 | 3 | 4 | 5;

export const BillingProcessStatus = {
    NUMBER_0: 0 as BillingProcessStatus,
    NUMBER_1: 1 as BillingProcessStatus,
    NUMBER_2: 2 as BillingProcessStatus,
    NUMBER_3: 3 as BillingProcessStatus,
    NUMBER_4: 4 as BillingProcessStatus,
    NUMBER_5: 5 as BillingProcessStatus
};
